import { useEffect, useState } from "react";
import axios from "axios";
import { BACKEND_URL } from "../lib/api";

export const CLUB_ROOMS_CHANNEL = "pfp-club-rooms";

// Demo mode: slugs of the club rooms switched on in Players Room admin (null while loading). Open lobbies follow the
// admin switch live: instantly in the same browser (BroadcastChannel), within 10s anywhere else, and on tab focus.
export const useClubRoomsOn = () => {
  const [on, setOn] = useState(null);
  useEffect(() => {
    let dead = false;
    const load = () => axios.get(`${BACKEND_URL}/api/club-rooms`).then((r) => !dead && setOn(r.data.on || [])).catch(() => !dead && setOn((v) => v || []));
    load();
    const id = setInterval(load, 10000);
    const onVis = () => document.visibilityState === "visible" && load();
    document.addEventListener("visibilitychange", onVis);
    const bc = "BroadcastChannel" in window ? new BroadcastChannel(CLUB_ROOMS_CHANNEL) : null;
    if (bc) bc.onmessage = (e) => (Array.isArray(e.data) ? setOn(e.data) : load());
    return () => { dead = true; clearInterval(id); document.removeEventListener("visibilitychange", onVis); bc?.close(); };
  }, []);
  return on;
};
